export default {
  infos: [],
  info: {},
  content: ''
}
